import React from 'react';
import { Container } from 'react-bootstrap';
const Confirmation = () => {
  return (
    <Container className="mt-5 text-center">
      <h1>Thank You!</h1>
      <p>Your message has been sent successfully. I will get back to you soon.</p>
    </Container>
  );
}
export default Confirmation;
